export const moduleWiseCategories = ["Module 1", "Module 2", "Module 3", "Module 4", "Module 5"];
export const moduleWiseData = [
  {
    name: "Correct",
    data: [30, 40, 45, 30, 49],
  },
];

export const speedTimeWiseCategories = [1, 2, 3, 4, 5, 6, 7];
export const speedTimeData = [
  {
    name: "Speed",
    data: [10, 15, 20, 30, 25, 35, 38],
  },
];

//  Average Lifetime Revenue
export const ViolationsBreakdownCategories = ["Paint", "Fire", "Metaverse", "RA", "Other"];
export const ViolationBrekadownData = [
  {
    name: "CLTV",
    data: [20, 15, 20, 30, 50],
  },
];

//  ARR MRR Breakdown
export const MrrArrCategories = ["Jan"];
export const MrrArrBrekadownData = [
  {
    name: "-",
    data: [0],
  },
];
//  ARR MRR Breakdown
export const SrrArrCategories = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"];
export const SrrArrBrekadownData = [
  {
    name: "Arr",
    data: [5, 10, 6, 20, 5, 10, 6, 15, 5, 10, 6, 20],
  },
];

//  Conversion Rate Breakdown
export const ConversionRateCategories = ["Converted to Paid", "Trial Users"];
export const ConversionRateBrekadownData = [
  {
    name:'',
    data: [5, 10],
  },
];
